import { parseRouteParamToInt } from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

export const DEFAULT_LISTING_ID = 0;

export type LCFTitleDescriptionRouteParams = {
  listingID: number;
};

export type LCFTitleDescriptionRouteParamsString = {
  listingID: string;
};

export const LCFTitleDescription = defineRoute<
  LCFTitleDescriptionRouteParams,
  LCFTitleDescriptionRouteParamsString
>({
  pathname: '/create-listing/[listingID]/title-description',
  nlPathname: '/maken-advertentie/[listingID]/title-description',
  options: { isLandlordRoute: true, isPublic: false },
  routeParamsStringifier: routeParams => {
    return {
      listingID: routeParams.listingID.toString(),
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      listingID:
        parseRouteParamToInt(routeParamsString.listingID) || DEFAULT_LISTING_ID,
    };
  },
});
